export default __webpack_public_path__ + "static/media/kubek2.48323251.jpg";